export default __webpack_public_path__ + "static/media/AR.22260323.svg";